/**
* DevExpress Analytics (diagram\elements\diagramElementSurface.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var baseSurface_1 = require("../../core/elements/baseSurface");
var _utils_1 = require("../../serializer/_utils");
var DiagramElementBaseSurface = (function (_super) {
    __extends(DiagramElementBaseSurface, _super);
    function DiagramElementBaseSurface(control, context, unitProperties) {
        var _this = _super.call(this, control, context, _utils_1.extend({}, DiagramElementBaseSurface._unitProperties, unitProperties)) || this;
        _this.template = 'dx-diagram-element';
        _this.selectiontemplate = 'dx-diagram-element-selection';
        _this.contenttemplate = 'dx-diagram-element-content';
        _this.margin = ko.observable(0);
        _this._disposables.push(_this.positionWidthWithoutMargins = ko.pureComputed(function () {
            return _this['position'].width() - _this.margin() * 2;
        }));
        _this._disposables.push(_this.positionLineHeightWithoutMargins = ko.pureComputed(function () {
            return _this['position'].lineHeight() - _this.margin() * 2;
        }));
        return _this;
    }
    DiagramElementBaseSurface._unitProperties = {
        _height: function (o) {
            return o.size.height;
        },
        _width: function (o) {
            return o.size.width;
        },
        _x: function (o) {
            return o.location.x;
        },
        _y: function (o) {
            return o.location.y;
        }
    };
    return DiagramElementBaseSurface;
}(baseSurface_1.SurfaceElementBase));
exports.DiagramElementBaseSurface = DiagramElementBaseSurface;
var DiagramElementSurface = (function (_super) {
    __extends(DiagramElementSurface, _super);
    function DiagramElementSurface(control, context) {
        var _this = _super.call(this, control, context, null) || this;
        _this.contenttemplate = 'dxdd-element-content-with-connecting-points';
        return _this;
    }
    DiagramElementSurface.prototype._getChildrenHolderName = function () { return 'connectingPoints'; };
    return DiagramElementSurface;
}(DiagramElementBaseSurface));
exports.DiagramElementSurface = DiagramElementSurface;
